

import React, { useEffect, useRef } from "react";
import { Route } from "react-router-dom";
import { InteractionStatus } from "@azure/msal-browser";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import LoadingOverlay from 'components/LoadingOverlay';
import { loginRequest } from 'auth/entra';

const PrivateRoute = ({ component: Component, ...args }) => {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const loginStarted = useRef(false);

  useEffect(() => {
    if (isAuthenticated) {
      loginStarted.current = false;
      return;
    }
    if (inProgress === InteractionStatus.None && !loginStarted.current) {
      loginStarted.current = true;
      instance.loginRedirect(loginRequest).catch(() => {
        loginStarted.current = false;
      });
    }
  }, [instance, inProgress, isAuthenticated]);

  return (
    <Route
      {...args}
      render={routeProps => isAuthenticated
        ? <Component {...routeProps} />
        : <LoadingOverlay loading={true}/>
      }
    />
  );
};

export default PrivateRoute;
